//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import M_TRA_CUSTOM_03 from './M_TRA_CUSTOM_03';
import { Loading } from '../../../../../Components/MUIs';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import IndexedDb from '../../../../../Services/IndexedDb/IndexedDb';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import useSearchUser from '../../../../../Hooks/useSearchUser';
import { PDFDocument } from 'pdf-lib';
import { Typography } from '@mui/material';
import { NavBarInfoActions } from '../../../../../Reducer/NavBarInfoReducer';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../../Hooks/back/useBackStack';
//#endregion

function M_TRA_CUSTOM_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { id } = useParams();
  const { searchUser } = useSearchUser();

  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  // 사업장 선택 상태
  const [custInfo, setCustInfo] = useState({
    custList: [],
    custCd: '',
  });

  // 탭 상태
  const [tabValue, setTabValue] = useState(0); // 0 = 교육자료, 1 = 교육동영상

  // 여러 파일 관리 상태 (관리자용과 동일)
  const [tempFileList, setTempFileList] = useState([]); // 업로드된 파일 리스트
  const [previewUrl, setPreviewUrl] = useState(null); // 교육 자료 미리보기 URL
  const [previewFileName, setPreviewFileName] = useState(''); // 현재 미리보기 중인 파일명

  // 부서 선택 상태 (단일 선택)
  const [selectedDepCd, setSelectedDepCd] = useState('');

  // 부서 리스트 (SearchLogic1 결과)
  const [departmentList, setDepartmentList] = useState([]);

  // refs
  const videoInputRef = useRef(null);
  const materialInputRef = useRef(null);
  const searchRef = useRef({
    custList: [],
    custCd: '',
  });

  const ToggleDrawer = (anchor, open) => () => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: open,
        type: open ? bottomSheetState?.type : bottomSheetState?.type,
      })
    );
  };
  //#endregion

  // 스택형 뒤로가기로 변경: 교육 자료 등록 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTra' })),
  });

  useEffect(() => {
    Init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const Init = async () => {
    setLoading(true);
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('교육 자료 등록'));

    try {
      const userData = await IndexedDb.GetUserInfo();
      const loginUserId = Commons.DecryptoAES(userData.userid);
      const newUserInfo = await searchUser(loginUserId);

      if (newUserInfo) {
        setUserInfo(newUserInfo);
        await SearchCust(newUserInfo);
        await SearchLogic1();
      }
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: '초기화 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  //사업장정보 조회(_value1:사용자정보)
  const SearchCust = async (_value1) => {
    setLoading(true);
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GET_AUTH_CUST_MANAGER',
            _USER_ID: Commons.EncryptAES(_value1.ID), // 사용자 ID
            _AUTH_CD: Commons.EncryptAES(_value1.AUTH_CD) || '', // 권한코드
          },
        ]
      );
      let data = result.data;
      let changeData = [];

      if (data.length === 0) {
        setCustInfo({
          custList: [],
          custCd: '',
        });
        searchRef.current = {
          custList: [],
          custCd: '',
        };
      } else if (data[0]?.type === 'Error') {
        //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return false;
      } else {
        data.forEach((_item) => {
          changeData.push({
            value: _item.custCd,
            name: _item.custNm,
          });
        });
        // setSelectedChip(changeData[0]);
        setCustInfo({
          ...custInfo,
          custList: changeData,
          custCd: changeData[0].value,
        });
        searchRef.current = {
          ...searchRef.current,
          custList: changeData,
          custCd: changeData[0].value,
        };
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  // 부서 리스트 조회
  const SearchLogic1 = async () => {
    setDepartmentList([]);
    setSelectedDepCd('');

    try {
      let userData = await IndexedDb.GetUserInfo();

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_CUSTOM_04_R1',
            _USER_ID: userData.userid || '', //로그인한 user 사업장코드
            _AUTH_CD: Commons.EncryptAES(userData.authCd) || '', //권한코드
            _CO_CD: Commons.EncryptAES(userData.coCd) || '', //회사코드
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', //사업장코드
            _searchText: Commons.EncryptAES('') || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          dispatch(
            showSnackbar({
              message: data[0]?.message || '부서가 없습니다.',
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          setDepartmentList(data); // 부서 리스트 세팅
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
    }
  };
  //#endregion
  //#region 저장
  // 교육 자료 저장 (여러 파일, 여러 부서에 저장)
  const HandleSave = async () => {
    setLoading(true);
    try {
      if (!selectedDepCd) {
        dispatch(
          showSnackbar({
            message: '대상 부서를 선택해주세요.',
            type: 'warning',
          })
        );
        return false;
      }

      const depCdList = [selectedDepCd];

      // tempFileList에 파일이 있는지 확인
      if (!tempFileList || tempFileList.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장할 파일이 없습니다. 파일을 업로드해주세요.',
            type: 'warning',
          })
        );
        return false;
      }

      // tempFileList에서 교육자료와 동영상 분리
      const eduFiles = tempFileList.filter((f) => f.type === 'edu');
      const videoFiles = tempFileList.filter((f) => f.type === 'video');

      // 조회된 모든 DEP_CD에 대해 파일 저장
      for (const depCd of depCdList) {
        // 교육자료 파일들 저장
        for (const eduFileItem of eduFiles) {
          if (!eduFileItem.file) continue;

          //DB저장용 경로(파일name포함)
          const eduPath = `Education/${searchRef.current.custCd}/${depCd}/DEP_BASIC/${eduFileItem.fileName}`;

          //서버저장용 경로(파일name빼고)
          const eduPathServer = `Education/${searchRef.current.custCd}/${depCd}/DEP_BASIC`;

          // 파일서버에 교육자료 업로드
          await SaveLogic3(eduPathServer, eduFileItem.file, null);

          // DB 저장 호출 (교육자료만 - SP_TRA_CUSTOM_04_U2 사용)
          await saveEduFileToDB(depCd, eduFileItem.fileName, eduPath);
        }

        // 동영상 파일들 저장
        for (const videoFileItem of videoFiles) {
          if (!videoFileItem.file) continue;

          //DB저장용 경로(파일name포함)
          const videoPath = `Video/${searchRef.current.custCd}/${depCd}/DEP_BASIC/${videoFileItem.fileName}`;

          //서버저장용 경로(파일name빼고)
          const videoPathServer = `Video/${searchRef.current.custCd}/${depCd}/DEP_BASIC`;

          // 파일서버에 동영상 업로드
          await SaveLogic2(videoPathServer, videoFileItem.file, null);

          // DB 저장 호출 (동영상만 - SP_TRA_CUSTOM_04_U1 사용)
          await saveVideoFileToDB(depCd, videoFileItem.fileName, videoPath);
        }
      }

      dispatch(
        showSnackbar({
          message: '저장 및 업로드 완료.',
          type: 'success',
        })
      );

      // tempFileList 초기화
      setTempFileList([]);
      setPreviewUrl(null);
      setPreviewFileName('');

      navigate('/M_TrainingPage');
    } catch (e) {
      console.error('저장 중 오류 발생:', e);
      dispatch(
        showSnackbar({
          message: e.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 교육자료만 DB에 저장 (SP_TRA_CUSTOM_04_U2 사용)
  const saveEduFileToDB = async (depCd, fileName, filePath) => {
    try {
      const requestData = [
        {
          procedureName: 'SP_TRA_CUSTOM_04_U2',
          _DEP_CD: Commons.EncryptAES(depCd) || '',
          _EDU_LOCATION: Commons.EncryptAES(filePath) || '',
          _EDU_FILE_NAME: Commons.EncryptAES(fileName) || '',
          _USER_ID: Commons.EncryptAES(userInfo.ID) || '',
        },
      ];

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        requestData
      );

      let isError = false;
      const data = result.data;

      if (Array.isArray(data)) {
        isError = data.some((item) => item.type === 'Error');
      } else if (data && data.type === 'Error') {
        isError = true;
      }

      if (isError) {
        const message = Array.isArray(data)
          ? data[0]?.message || '교육자료 DB 저장 오류'
          : data.message || '교육자료 DB 저장 오류';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('saveEduFileToDB 오류:', error);
      dispatch(
        showSnackbar({
          message: error.message || '교육자료 DB 저장 실패',
          type: 'error',
        })
      );
      return false;
    }
  };

  // 동영상만 DB에 저장 (SP_TRA_CUSTOM_04_U1 사용)
  const saveVideoFileToDB = async (depCd, fileName, filePath) => {
    try {
      const requestData = [
        {
          procedureName: 'SP_TRA_CUSTOM_04_U1',
          _DEP_CD: Commons.EncryptAES(depCd) || '',
          _VIDEO_LOCATION: Commons.EncryptAES(filePath) || '',
          _VIDEO_FILE_NAME: Commons.EncryptAES(fileName) || '',
          _USER_ID: Commons.EncryptAES(userInfo.ID) || '',
        },
      ];

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        requestData
      );

      let isError = false;
      const data = result.data;

      if (Array.isArray(data)) {
        isError = data.some((item) => item.type === 'Error');
      } else if (data && data.type === 'Error') {
        isError = true;
      }

      if (isError) {
        const message = Array.isArray(data)
          ? data[0]?.message || '동영상 DB 저장 오류'
          : data.message || '동영상 DB 저장 오류';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('saveVideoFileToDB 오류:', error);
      dispatch(
        showSnackbar({
          message: error.message || '동영상 DB 저장 실패',
          type: 'error',
        })
      );
      return false;
    }
  };

  // DB 저장
  const saveToDB = async (depCd, vName, vPath, eName, ePath) => {
    try {
      const requestData = [
        {
          procedureName: 'SP_TRA_CUSTOM_04_U3',
          _CUST_CD: Commons.EncryptAES(searchRef.current.custCd),
          _DEP_CD: Commons.EncryptAES(depCd),
          _VIDEO_LOCATION: Commons.EncryptAES(vPath || ''),
          _VIDEO_FILE_NAME: Commons.EncryptAES(vName || ''),
          _EDU_LOCATION: Commons.EncryptAES(ePath || ''),
          _EDU_FILE_NAME: Commons.EncryptAES(eName || ''),
          _USER_ID: Commons.EncryptAES(userInfo.ID),
        },
      ];

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        requestData
      );

      let isError = false;
      const data = result.data;

      if (Array.isArray(data)) {
        isError = data.some((item) => item.type === 'Error');
      } else if (data && data.type === 'Error') {
        isError = true;
      }

      if (isError) {
        // 배열일 경우 첫 메시지, 아니면 단일 메시지 출력
        const message = Array.isArray(data)
          ? data[0]?.message || 'DB 저장 오류'
          : data.message || 'DB 저장 오류';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('saveToDB 오류:', error);
      dispatch(
        showSnackbar({
          message: error.message || 'DB 저장 실패',
          type: 'error',
        })
      );
      return false;
    }
  };

  // 동영상파일 파일서버에 저장
  const SaveLogic2 = async (_value1, _value2, oldFullPath) => {
    try {
      // 기존파일 삭제
      if (oldFullPath) {
        await MoveAndReplaceFile(oldFullPath, null, null, null);
      }
      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await UploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.ID);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '동영상파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 교육자료파일 파일서버에 저장
  const SaveLogic3 = async (_value1, _value2, oldFullPath) => {
    try {
      // 기존파일삭제
      if (oldFullPath) {
        await MoveAndReplaceFile(oldFullPath, null, null, null);
      }

      // 미리보기파일 삭제
      if (_value2) {
        const previewPath = `PreviewFiles/${_value2.name}`;
        await MoveAndReplaceFile(previewPath, null, null, null);
      }

      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await UploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.ID);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const savePath = finalSavePath.replace(/\\/g, '/');

      // PDF로 변환 가능한 파일 형식 확인 및 변환 ( moveAndReplaceFile 함수를 사용할 경우 옮기는 과정에서 파일이 깨짐. 폴더에 직접변환처리)
      const ext = _value2.name.split('.').pop()?.toLowerCase();
      const convertibleExts = [
        'hwp',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ];

      if (convertibleExts.includes(ext)) {
        const convertedUrl = await ConvertFileToPdf(savePath); // 실제 저장된 위치에서 변환!!!

        if (!convertedUrl) {
          dispatch(
            showSnackbar({
              message: `${ext.toUpperCase()} → PDF 변환 실패`,
              type: 'error',
            })
          );
          return savePath;
        }

        // 성공 시 PDF도 저장되었음
        // dispatch(showSnackbar({ message: 'HWP → PDF 변환 완료', type: 'success' }));
      }

      return savePath;
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };
  //#endregion

  //#region 나머지 함수
  //사업장 선택 핸들러
  const HandleWorkplaceChange = (event) => {
    setCustInfo({
      ...custInfo,
      custCd: event,
    });
    searchRef.current = {
      ...searchRef.current,
      custCd: event,
    };

    SearchLogic1();
  };

  //#region 파일 업로드 핸들러들
  // 여러 파일 업로드 처리 (교육자료)
  const HandleMaterialUpload = async (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    setLoading(true);
    try {
      for (const file of files) {
        // 파일을 서버에 업로드하고 URL 받기
        const { path, url } = await UploadFileAndGetUrl2(file, null);

        // 임시 파일 리스트에 추가
        const newFile = {
          id: Date.now() + Math.random(), // 고유 ID
          type: 'edu',
          fileName: file.name,
          filePath: path,
          fileUrl: url || FixUrl(path),
          file: file, // 원본 파일 객체
          regDate: new Date().toISOString().split('T')[0], // 오늘 날짜
        };

        setTempFileList((prev) => [...prev, newFile]);

        // 첫 번째 파일이면 미리보기 설정
        if (tempFileList.length === 0 && url) {
          setPreviewUrl(url);
          setPreviewFileName(file.name);
        }
      }

      dispatch(
        showSnackbar({
          message: `${files.length}개의 파일이 추가되었습니다.`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `파일 업로드 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
      if (materialInputRef.current) materialInputRef.current.value = '';
    }
  };

  // 여러 파일 업로드 처리 (동영상)
  const HandleVideoUpload = async (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    setLoading(true);
    try {
      for (const file of files) {
        if (!file.type.startsWith('video/')) {
          dispatch(
            showSnackbar({
              message: `${file.name}은(는) 비디오 파일이 아닙니다.`,
              type: 'warning',
            })
          );
          continue;
        }

        // 파일을 서버에 업로드하고 URL 받기
        const { path, url } = await UploadFileAndGetUrl2(file, null);

        // 임시 파일 리스트에 추가
        const newFile = {
          id: Date.now() + Math.random(), // 고유 ID
          type: 'video',
          fileName: file.name,
          filePath: path,
          fileUrl: url || FixUrl(path),
          file: file, // 원본 파일 객체
          regDate: new Date().toISOString().split('T')[0], // 오늘 날짜
        };

        setTempFileList((prev) => [...prev, newFile]);
      }

      dispatch(
        showSnackbar({
          message: `${files.length}개의 동영상이 추가되었습니다.`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `파일 업로드 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
      if (videoInputRef.current) videoInputRef.current.value = '';
    }
  };

  const HandleRemoveVideo = () => {
    // 더 이상 사용하지 않음 (tempFileList에서 관리)
  };

  const HandleRemoveMaterial = () => {
    // 더 이상 사용하지 않음 (tempFileList에서 관리)
  };

  // 파일 리스트에서 삭제
  const HandleFileListDelete = (fileRow) => {
    if (!fileRow) return;

    // 리스트에서 제거
    setTempFileList((prev) => prev.filter((f) => f.id !== fileRow.id));

    // 삭제된 파일이 현재 미리보기 중인 파일이면 초기화
    if (fileRow.type === 'edu') {
      if (previewUrl === fileRow.fileUrl) {
        // 다음 파일로 미리보기 변경
        const remainingFiles = tempFileList.filter(
          (f) => f.id !== fileRow.id && f.type === 'edu'
        );
        if (remainingFiles.length > 0) {
          setPreviewUrl(remainingFiles[0].fileUrl);
          setPreviewFileName(remainingFiles[0].fileName);
        } else {
          setPreviewUrl(null);
          setPreviewFileName('');
        }
      }
    }

    dispatch(
      showSnackbar({
        message: `${fileRow.fileName} 파일이 제거되었습니다.`,
        type: 'info',
      })
    );
  };

  // 파일 다운로드
  const HandleFileListDownload = async (fileRow) => {
    if (!fileRow || !fileRow.filePath) {
      dispatch(
        showSnackbar({
          message: '다운로드할 파일 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const fileUrl = fileRow.filePath;
      const fileName =
        fileRow.fileName ||
        decodeURIComponent(fileUrl.split('/').pop()) ||
        'downloaded_file';

      const params = {
        FileName: fileName,
        Url: fileUrl,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  // 파일 리스트 행 클릭 (미리보기)
  const HandleTempFileRowClick = (fileRow) => {
    if (!fileRow) return;

    if (fileRow.type === 'edu') {
      // 교육자료 미리보기
      if (fileRow.fileUrl) {
        setPreviewUrl(fileRow.fileUrl);
        setPreviewFileName(fileRow.fileName);
      }
    }
  };
  //#endregion

  //#region 교육 자료 미리보기 함수
  // 파일 URL 얻기
  const GetFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = FixUrl(relativePath);
    const fullUrl = `${Global.file.useUrl}files/${fixedPath}`;
    return fullUrl;
  };

  // URL 인코딩 처리
  const FixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  // 파일 선택 후 처리
  const MoveAndReplaceFile = async (
    oldFilePath, // 기존 파일 경로 (이전 파일 위치, 없으면 빈 문자열)
    sourcePreviewPath, // 현재 파일 위치 (임시 경로 등, 미리보기 경로)
    newFileName, // 새로 저장할 파일명
    targetPath // 최종 저장할 디렉터리 경로 (예: Education/고객코드/부서코드/DEP_BASIC)
  ) => {
    try {
      const payload = {
        oldFilePath,
        sourcePreviewPath,
        newFileName,
        targetPath,
      };

      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );

      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 이동 실패');
      }

      return data; // 성공 시 서버 응답 반환 (true 등)
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '파일 저장 실패',
          type: 'error',
        })
      );
      console.error('MoveAndReplaceFile Error:', e);
      return null; // 실패 시 null 반환
    }
  };

  // 서버에 파일 업로드 후 URL 얻기 (여러 파일용)
  const UploadFileAndGetUrl2 = async (file, depCd) => {
    const ext = file.name.split('.').pop().toLowerCase();

    let uploadedFilePath;

    if (ext === 'pdf') {
      const arrayBuffer = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      pdfDoc.setTitle(file.name);
      const modifiedBytes = await pdfDoc.save();
      const modifiedFile = new File(
        [new Blob([modifiedBytes], { type: 'application/pdf' })],
        file.name,
        { type: 'application/pdf' }
      );
      uploadedFilePath = await UploadFile2(modifiedFile, depCd);
    } else {
      uploadedFilePath = await UploadFile2(file, depCd);
    }

    if (!uploadedFilePath) {
      return { path: '', url: '' };
    }

    const { path, url } = uploadedFilePath;

    return {
      path: path,
      url: url || FixUrl(path),
    };
  };

  // 실제 파일 업로드 API 호출 (여러 파일용)
  const UploadFile2 = async (_file, depCd) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        // 대용량 파일: 청크 업로드
        finalSavePath = await UploadInChunks(filePath, _file);
      } else {
        // 일반 파일 업로드
        const formData = new FormData();
        formData.append('UserId', Commons.EncryptAES(userInfo.ID));
        formData.append('FilePath', filePath);
        formData.append('FormFile', _file);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const cleanedPath = finalSavePath
        .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
        .replace(/\\/g, '/');

      // PDF로 변환 가능한 파일 형식 확인
      const ext = _file.name.split('.').pop()?.toLowerCase();
      const convertibleExts = [
        'hwp',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ];

      // PDF로 변환 가능한 파일이면 변환된 PDF 경로(url)를 직접 반환
      if (convertibleExts.includes(ext)) {
        const pdfUrl = await ConvertFileToPdf(cleanedPath);

        if (!pdfUrl) {
          dispatch(
            showSnackbar({
              message: `${ext.toUpperCase()} 파일 PDF 변환 실패. 원본 파일로 표시합니다.`,
              type: 'warning',
            })
          );
          return { path: cleanedPath, url: null };
        }

        return { path: cleanedPath, url: pdfUrl };
      }

      return { path: cleanedPath, url: null };
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 실제 파일 업로드 API 호출
  const UploadFile = async (_file) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        // 대용량 파일: 청크 업로드
        finalSavePath = await UploadInChunks(filePath, _file);
      } else {
        // 일반 파일 업로드
        const formData = new FormData();
        formData.append('UserId', Commons.EncryptAES(userInfo.ID));
        formData.append('FilePath', filePath);
        formData.append('FormFile', _file);

        const result = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = result?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      } else {
        const cleanedPath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        const ext = _file.name.split('.').pop()?.toLowerCase();

        // PDF로 변환 가능한 파일 형식: 한글, 워드, 엑셀, 파워포인트
        const convertibleExts = [
          'hwp',
          'doc',
          'docx',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
        ];

        if (convertibleExts.includes(ext)) {
          const pdfUrl = await ConvertFileToPdf(cleanedPath);
          return pdfUrl || null;
        }

        // PDF 파일과 이미지 파일은 그대로 반환
        return cleanedPath;
      }
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 파일 확장자 추출 헬퍼
  const GetExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop().toLowerCase() || '';
  };

  // 미리보기 렌더 함수 (previewUrl 기반)
  const RenderPreview = () => {
    if (!previewUrl) {
      return (
        <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
          파일을 선택하면 미리보기가 표시됩니다.
        </Typography>
      );
    }

    const ext = GetExtension(previewUrl);
    const fullUrl = Global.file.useUrl + 'files/' + previewUrl;

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{
            maxWidth: '100%',
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      );
    }

    if (
      ['pdf', 'hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)
    ) {
      const pdfUrl =
        ext !== 'pdf'
          ? fullUrl.replace(/\.(hwp|doc|docx|ppt|pptx|xls|xlsx)$/i, '.pdf')
          : fullUrl;

      return (
        <iframe
          src={pdfUrl}
          title="PDF 미리보기"
          allow="fullscreen"
          style={{
            width: '100%',
            minHeight: '400px',
            border: 'none',
            borderRadius: '4px',
          }}
        />
      );
    }

    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        지원하지 않는 형식입니다.
      </Typography>
    );
  };

  const UploadInChunks = async (
    filePathOrFile,
    file,
    chunkSize = 5 * 1024 * 1024
  ) => {
    // filePath만 전달된 경우와 file만 전달된 경우 처리
    let actualFile = file || filePathOrFile;
    let actualFilePath = file ? filePathOrFile : 'PreviewFiles';

    if (!actualFile || !actualFile.size) {
      throw new Error('파일 정보가 없습니다.');
    }

    const totalChunks = Math.ceil(actualFile.size / chunkSize);
    const saveName = actualFile.name;

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, actualFile.size);
      const chunk = actualFile.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkIndex', i);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', saveName);
      formData.append('UserId', Commons.EncryptAES(userInfo.ID));
      formData.append('FilePath', actualFilePath);

      await Commons.Axios(
        'chunk',
        Global.file.useUrl + Global.urls.Execute.UploadChunk,
        null,
        formData
      );
    }

    // 병합 요청
    const mergeResponse = await Commons.Axios(
      'post',
      Global.file.useUrl + Global.urls.Execute.MergeChunks,
      null,
      {
        fileName: saveName,
        filePath: actualFilePath,
        userId: Commons.EncryptAES(userInfo.ID),
      }
    );

    return mergeResponse?.data?.filePath || '';
  };

  // 파일 확장자에 따른 PDF 변환 함수
  const ConvertFileToPdf = async (_filePath) => {
    if (!_filePath) {
      console.error('ConvertFileToPdf: filePath가 없습니다.');
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      // 파일 경로에서 확장자 추출
      const fileName =
        _filePath.split('/').pop() || _filePath.split('\\').pop();
      const ext = fileName.split('.').pop()?.toLowerCase();

      // 확장자에 따라 다른 변환 API 선택
      let convertApiUrl = '';
      switch (ext) {
        case 'hwp':
          convertApiUrl = Global.urls.Execute.ConvertHwpToPdf;
          break;
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
          convertApiUrl = Global.urls.Execute.ConvertOfficeToPdf;
          break;
        default:
          console.error(
            `ConvertFileToPdf: 지원하지 않는 파일 형식입니다: ${ext}`
          );
          return null;
      }

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + convertApiUrl,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
        // 서버가 '/PreviewFiles/xxx.pdf' 형태로 반환하면 'files/PreviewFiles/xxx.pdf'
      } else {
        console.error('ConvertFileToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.error('ConvertFileToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };
  //#endregion

  // 등록 대상 목록에 표시할 최종 선택 항목 (단일 선택)
  const GetFinalSelectedItems = () => {
    if (!selectedDepCd) return [];

    const selectedDept = departmentList.find((d) => d.DEP_CD === selectedDepCd);
    if (!selectedDept) return [];

    return [
      {
        id: selectedDept.DEP_CD,
        name: selectedDept.DEP_NM,
        depCd: selectedDept.DEP_CD,
        backgroundColor: '#E3F2FD',
        color: '#1976d2',
      },
    ];
  };

  // 최종선택된 DEP_CD 추출 (단일 선택)
  const GetExportDepCds = () => {
    if (!selectedDepCd) return [];
    return [selectedDepCd];
  };

  // 부서 선택 핸들러
  const HandleDepartmentSelect = (depCd) => {
    setSelectedDepCd(depCd);
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TRA_CUSTOM_03
        ToggleDrawer={ToggleDrawer}
        bottomSheetState={bottomSheetState}
        id={id}
        custInfo={custInfo}
        tempFileList={tempFileList}
        departmentList={departmentList}
        selectedDepCd={selectedDepCd}
        videoInputRef={videoInputRef}
        materialInputRef={materialInputRef}
        tabValue={tabValue}
        setTabValue={setTabValue}
        // 함수
        dispatch={dispatch}
        HandleSave={HandleSave}
        HandleWorkplaceChange={HandleWorkplaceChange}
        HandleVideoUpload={HandleVideoUpload}
        HandleRemoveVideo={HandleRemoveVideo}
        HandleMaterialUpload={HandleMaterialUpload}
        HandleRemoveMaterial={HandleRemoveMaterial}
        GetFinalSelectedItems={GetFinalSelectedItems}
        RenderPreview={RenderPreview}
        HandleFileListDelete={HandleFileListDelete}
        HandleFileListDownload={HandleFileListDownload}
        HandleTempFileRowClick={HandleTempFileRowClick}
        HandleDepartmentSelect={HandleDepartmentSelect}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TRA_CUSTOM_03F;
